export const acceptedSummaryClasses = {
  typeText: {
    '& > span': { fontWeight: 600, marginRight: '8px' },
  },
  typesContainer: {
    padding: '8px',
  },
}
